export enum FeatureFlagKeys {
    RecentOrdersAndFaves = 'recentOrdersAndFaves',
    SkeletonPages = 'skeletonPages',
    RedeemInPerson = 'redeemInPerson',
    NewCustomizeProduct = 'newCustomizeProduct',
    ShowLoginTemporarilyUnavailableMessage = 'showLoginTemporarilyUnavailableMessage',
}

export class FeatureFlagGeneric {
    key: FeatureFlagKeys;
    live: boolean;
    threshold: number;
    eventSent: boolean;
    active: boolean;

    constructor(init?: Partial<FeatureFlagGeneric>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): FeatureFlagGeneric {
        return new FeatureFlagGeneric({
            key: obj.key,
            live: Boolean(obj.live),
            threshold: Number(obj.threshold),
            active: obj.active ?? false,
        });
    }
}

export class FeatureFlagHighlight extends FeatureFlagGeneric {
    displayStartDate?: Date | null;
    displayEndDate?: Date | null;

    constructor(init?: Partial<FeatureFlagHighlight>) {
        super(init);
        this.displayStartDate = init?.displayStartDate ? new Date(init.displayStartDate) : null;
        this.displayEndDate = init?.displayEndDate ? new Date(init.displayEndDate) : null;
    }

    public static Make(obj: any): FeatureFlagHighlight {
        return new FeatureFlagHighlight({
            key: obj.key,
            live: Boolean(obj.live),
            threshold: Number(obj.threshold),
            displayStartDate: obj.displayStartDate,
            displayEndDate: obj.displayEndDate,
            active: obj.active ?? false,
        });
    }
}

export class FeatureFlagItem extends FeatureFlagGeneric {
    constructor(init?: Partial<FeatureFlagItem>) {
        super(init);
    }

    public static Make(obj: any): FeatureFlagItem {
        return new FeatureFlagItem({
            key: obj.key,
            live: Boolean(obj.live),
            threshold: Number(obj.threshold),
            active: obj.active ?? false,
        });
    }
}

export const getFeatureFlagItem = (
    items: Array<FeatureFlagGeneric>,
    key: FeatureFlagKeys
): FeatureFlagGeneric | null => {
    const item = items.find((i) => i.key === key);
    return item ?? null;
};

export const getFeatureHighlight = (
    items: Array<FeatureFlagHighlight>,
    key: FeatureFlagKeys
): FeatureFlagHighlight | null => {
    const item = items.find((i) => i.key === key);
    return item ?? null;
};
